export type ProfileDocument = {
  id: number;
  fileUrl: string;
  fileKey: string;
  contentType: string;
  type: ProfileDocumentType;
  issueDate: string; // type string to bind directly to date input
  expirationDate: string; // same as above
  displayName: string;
  actionByType: ActionByType;
};

export enum ActionByType {
  Mariner = "Mariner",
  Crewing = "Crewing",
  JobOrder = "JobOrder",
}

export enum ProfileDocumentType {
  MMC = "MMC",
  PASSPORT = "PASSPORT",
  TWIC = "TWIC",
  MEDICAL_CERT = "MEDICAL_CERT",
  COVID_VACCINE_CARD = "COVID_VACCINE_CARD",
  DRUG_CARD = "DRUG_CARD",
  TRAINING = "TRAINING",
  SAFETY_HEALTH_FORM = "SAFETY_HEALTH_FORM",
  SIGN_ON_FORM = "SIGN_ON_FORM",
  OTHER = "OTHER",
}

export const ProfileDocumentTypeLabel: {
  [key in ProfileDocumentType]: string;
} = {
  [ProfileDocumentType.MMC]: "MMC",
  [ProfileDocumentType.PASSPORT]: "Passport",
  [ProfileDocumentType.TWIC]: "TWIC",
  [ProfileDocumentType.MEDICAL_CERT]: "Medical Cert.",
  [ProfileDocumentType.COVID_VACCINE_CARD]: "Covid Vaccine Card",
  [ProfileDocumentType.DRUG_CARD]: "Drug Card",
  [ProfileDocumentType.TRAINING]: "Training",
  [ProfileDocumentType.SAFETY_HEALTH_FORM]: "Safety and Health Form",
  [ProfileDocumentType.SIGN_ON_FORM]: "Sign-on Form",
  [ProfileDocumentType.OTHER]: "Other",
};

export enum ProfileDocumentOperationType {
  LOAD = "LOAD",
  UPLOAD = "UPLOAD",
  DOWNLOAD = "DOWNLOAD",
  EDIT = "EDIT",
  DELETE = "DELETE",
}

export enum ProfileDocumentStatus {
  NOT_UPLOADED = "NOT_UPLOADED",
  UPLOADED = "UPLOADED",
  EXPIRING_SOON = "EXPIRING_SOON",
  EXPIRED = "EXPIRED",
}

export const ProfileDocumentStatusLabel: {
  [key in ProfileDocumentStatus]: string;
} = {
  [ProfileDocumentStatus.NOT_UPLOADED]: "Not Uploaded",
  [ProfileDocumentStatus.UPLOADED]: "Uploaded",
  [ProfileDocumentStatus.EXPIRING_SOON]: "Expiring Soon",
  [ProfileDocumentStatus.EXPIRED]: "Expired",
};